import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { DashFrame } from 'legacy/dash-blocks/dash-frame/DashFrame'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import AppHeader from 'legacy/components/AppHeader'
import { type RetailerScopedRouteParams } from 'legacy/common/types'
import { usePerformanceMetricsBehaviour } from 'legacy/sections/analytics/components/performance-metrics/utils/performanceMetrics.hooks'
import { PerformanceMetricsFilters } from 'legacy/sections/analytics/components/performance-metrics/components/PerformanceMetricsFilters'
import { PerformanceMetricsBody } from 'legacy/sections/analytics/components/performance-metrics/components/PerformanceMetricsBody'

interface Props extends DashRouteComponentProps<RetailerScopedRouteParams> {}

export const PerformanceMetrics: FunctionComponent<Props> = ({ match: { path, params } }) => {
  const title = <FormattedMessage id="performanceMetrics.title" />
  const behaviour = usePerformanceMetricsBehaviour({ path, params })

  return (
    <DashFrame
      header={<AppHeader title={title} />}
      contentBar={<PerformanceMetricsFilters {...behaviour} />}
      contentBody={<PerformanceMetricsBody {...behaviour} />}
    />
  )
}
